<template lang="pug">
  .component-zucchetti

    ModalReveal(@modalOpen="checkClient")
      span(slot="trigger" )
        button.button Visualizza tracciato
      div
        label Enable debug
        input(type="checkbox", v-model="query.debug")
      div
        label Pn serial
          input(type="text", v-model="query.pn_serial")
      textarea(v-if="data" :value="data")
      ActionButton(:action="download") Load
</template>
<script>
import ModalReveal from "../../../structure/foundation/ModalReveal.vue";
import ActionButton from "../../../structure/ui/ActionButton.vue";
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../maggieHelper";

export default {
  name: 'DownloadInvoiceAsEvilVersion',
  components: {ActionButton, ModalReveal},
  data() {
    return {
      query: {
        debug: false,
        pn_serial: null,
      },
      data: null,
      hasId: false
    }
  },
  methods: {
    checkClient() {
      return KeplerBackofficeSdk.clients.select(this.invoice.billing_info.client_id).get((data) => {
        this.hasId = data.extra !== null && data.extra.hasOwnProperty('zucchetti')
      })
    },
    download() {
      if (!this.hasId){
        MaggieHelper.notification("ANCODICE", 'ANCODICE missing')
      }
      return KeplerBackofficeSdk.invoices.select(this.invoice).downloadZucchetti(this.query, (data) => {
        this.data = data
      })
    }
  },
  props: {
    invoice: {
      type: Object
    }
  }
}
</script>
<style scoped lang="sass">

</style>



// WEBPACK FOOTER //
// DownloadInvoiceAsEvilVersion.vue?021c103f